import { Component, OnInit } from '@angular/core';
import { Validators, AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';

@Component({
  selector: 'app-analysis-plan',
  templateUrl: './analysis-plan.component.html',
  styleUrls: ['./analysis-plan.component.css']
})
export class AnalysisPlanComponent implements OnInit {

  FormFmcode: UntypedFormGroup;
  yearid: string = "";
  yearTh: string = "";
  yearidLb: string = "";
  yearLblast: string = "";
  yearLst: string = "";
  yearLft: string = "";

  isLoading = false;
  summarycaneFm: any = [];
  reducer = (previousValue, currentValue) => previousValue + currentValue;

  constructor(private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    this.edit_st = 0
    //this.test_as();
  }

  dataplant = [];
  sYear = [];
  fmcode = '';
  edit_st: number;
  listYear = [
    ['2324', '6667', '2566/2567', '2565/2566', '66/67', '66'],
    ['2425', '6768', '2567/2568', '2566/2567', '67/68', '67'],
  ];

  selectYear() {
    let ar = this.sYear;
    this.yearid = ar[0];
    this.yearidLb = ar[1];
    this.yearTh = ar[2];
    this.yearLblast = ar[3];
    this.yearLst = ar[4];
    this.yearLft = ar[5];

    console.log('sYear:', this.sYear);
  }


  // ค้นหาข้อมูล
  submited = false;
  Finddata() {
    let fmcode = this.fmcode;
    if (fmcode == undefined || fmcode == '') {
      this.submited = false;
      alert(" !! กรอกรหัสชาวไร่ !!");
    }
    else {
      this.submited = true;
      this.LoadFarmerdata();
      this.LoadLonedata();
      //this.LoadTKSdata();
    }
  }

  Chkmlong = [];
  LoadLonedata() {
    this.Chkmlong = [];
    let fmcode = this.fmcode;
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_DataTKS" + this.yearLft + "]&w=fmcode_b1='" + fmcode + "'";
    axios.get(url)
      .then(res => {
        let data = res.data;
        if (data.length >= 1) {
          this.Chkmlong = data[0];
          console.log('Chkmlong:', data);
        }
      })
  }

  // โหลดข้อมูลส่วนบุคคลชาวไร่ ประวัติการส่งอ้อย + ข้อมูลชาวไร่ ,หนี้ค้างแต่ละปี
  farmerdata: [];
  onefarmerdata: any;
  loanData: [];

  setYear() {
    // Define the starting string****
    const startString = this.yearLst;
    // Split the start string into two numbers
    const [start, end] = startString.split('/').map(Number);
    // Initialize an empty array to store the results
    this.yearStep = [];
    // Use a for loop to generate the desired array
    for (let i = 0; i < 7; i++) {
      const currentStart = start + i;
      const currentEnd = end + i;
      this.yearStep.push(`${currentStart}/${currentEnd}`);
    }
    // Print the resulting array**
    console.log('yearStep:', this.yearStep);

  }
  yearStep = [];
  LoadFarmerdata() {
    let fmcode = this.fmcode;

    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_AnalysisPlan]&w=yaer_id='" + this.yearLft + "' fmcode_b1='" + fmcode + "'";
    axios.get(url)
      .then(res => {
        let data = res.data;
        if (data.length >= 1) {
          data = data.map(item => {
            return { ...item, modify: false };
          });
          this.dataplant = data;
          console.log('AnalysisPlan:', data)
          this.setYear();

        }
      }).catch(err => { throw (err); })
  }

  test_as() {
    let data = [
      {
        "id": 1,
        "yaer_id": "2324",
        "fmcode": "213995",
        "fmcode_b1": "0000213995",
        "fmname": "นายไพรัช  พลเจริญ",
        "SUPZONE": "01",
        "cre_dt": "2023-09-16T11:21:59.607Z",
        "cre_by": "0",
        "upd_dt": "2023-09-16T11:21:59.607Z",
        "upd_by": "0",
        "ErTarYield": 0,
        "ErTarArea01": 0,
        "ErTarArea02": 0,
        "ErTarArea03": 0,
        "ErTarArea04": 0,
        "ErTarArea05": 0,
        "ErTarArea06": 0,
        "ErTarArea07": 0,
        "SrTarYield": 0,
        "SrTarArea01": 0,
        "SrTarArea02": 0,
        "SrTarArea03": 0,
        "SrTarArea04": 0,
        "SrTarArea05": 0,
        "SrTarArea06": 0,
        "SrTarArea07": 0,
        "StTarYield": 0,
        "StTarArea01": 0,
        "StTarArea02": 0,
        "StTarArea03": 0,
        "StTarArea04": 0,
        "StTarArea05": 0,
        "StTarArea06": 0,
        "StTarArea07": 0,
        "DeCutCost": 0,
        "cutHarvester01": 0,
        "cutHarvester02": 0,
        "cutHarvester03": 0,
        "cutHarvester06": 0,
        "cutHarvester07": 0,
        "cutService01": 0,
        "cutService02": 0,
        "cutService03": 0,
        "cutService06": 0,
        "cutService07": 0,
        "TruckService01": 0,
        "TruckService02": 0,
        "TruckService03": 0,
        "TruckService06": 0,
        "TruckService07": 0,
        "ForkliftService01": 0,
        "ForkliftService02": 0,
        "ForkliftService03": 0,
        "ForkliftService06": 0,
        "ForkliftService07": 0,
        "TractorService01": 0,
        "TractorService02": 0,
        "TractorService03": 0,
        "TractorService06": 0,
        "TractorService07": 0,
        "addMoney01": 0,
        "addMoney02": 0,
        "addMoney03": 0,
        "addMoney04": 0,
        "addMoney05": 0,
        "addMoney06": 0,
        "addMoney07": 0,
        "debtList1_name": null,
        "debtList1_01": 0,
        "debtList1_02": 0,
        "debtList1_03": 0,
        "debtList1_04": 0,
        "debtList1_05": 0,
        "debtList1_06": 0,
        "debtList1_07": 0,
        "debtList2_name": null,
        "debtList2_01": 0,
        "debtList2_02": 0,
        "debtList2_03": 0,
        "debtList2_04": 0,
        "debtList2_05": 0,
        "debtList2_06": 0,
        "debtList2_07": 0,
        "debtList3_name": null,
        "debtList3_01": 0,
        "debtList3_02": 0,
        "debtList3_03": 0,
        "debtList3_04": 0,
        "debtList3_05": 0,
        "debtList3_06": 0,
        "debtList3_07": 0,
        "modify": false
      }
    ];

    this.dataplant = data;
    this.run_val();
    this.yearStep = ["66/67", "67/68", "68/69", "69/70", "70/71", "71/72", "72/73"];
    console.log('AnalysisPlan:', this.dataplant)

  }
  run_val() {
    let dt = this.dataplant[0];
    //dt.Chkm =this.Chkmlong[0];
    dt.canePrice = 1100; //ราคาอ้อย
    dt.interest = 4.525; //ดอกเบี้ย

    dt.sumArea01 = (dt.ErTarArea01 + dt.SrTarArea01 + dt.StTarArea01);
    dt.sumArea02 = (dt.ErTarArea02 + dt.SrTarArea02 + dt.StTarArea02);
    dt.sumArea03 = (dt.ErTarArea03 + dt.SrTarArea03 + dt.StTarArea03);
    dt.sumArea04 = (dt.ErTarArea04 + dt.SrTarArea04 + dt.StTarArea04);
    dt.sumArea05 = (dt.ErTarArea05 + dt.SrTarArea05 + dt.StTarArea05);
    dt.sumArea06 = (dt.ErTarArea06 + dt.SrTarArea06 + dt.StTarArea06);
    dt.sumArea07 = (dt.ErTarArea07 + dt.SrTarArea07 + dt.StTarArea07);

    dt.sumlastArea01 = ((dt.ErTarArea01 * dt.ErTarYield) + (dt.SrTarArea01 * dt.SrTarYield) + (dt.StTarArea01 * dt.StTarYield));
    dt.sumlastArea02 = ((dt.ErTarArea02 * dt.ErTarYield) + (dt.SrTarArea02 * dt.SrTarYield) + (dt.StTarArea02 * dt.StTarYield));
    dt.sumlastArea03 = ((dt.ErTarArea03 * dt.ErTarYield) + (dt.SrTarArea03 * dt.SrTarYield) + (dt.StTarArea03 * dt.StTarYield));
    dt.sumlastArea04 = ((dt.ErTarArea04 * dt.ErTarYield) + (dt.SrTarArea04 * dt.SrTarYield) + (dt.StTarArea04 * dt.StTarYield));
    dt.sumlastArea05 = ((dt.ErTarArea05 * dt.ErTarYield) + (dt.SrTarArea05 * dt.SrTarYield) + (dt.StTarArea05 * dt.StTarYield));
    dt.sumlastArea06 = ((dt.ErTarArea06 * dt.ErTarYield) + (dt.SrTarArea06 * dt.SrTarYield) + (dt.StTarArea06 * dt.StTarYield));
    dt.sumlastArea07 = ((dt.ErTarArea07 * dt.ErTarYield) + (dt.SrTarArea07 * dt.SrTarYield) + (dt.StTarArea07 * dt.StTarYield));

    dt.sumCanePrice01 = (dt.canePrice * dt.sumlastArea01);
    dt.sumCanePrice02 = (dt.canePrice * dt.sumlastArea02);
    dt.sumCanePrice03 = (dt.canePrice * dt.sumlastArea03);
    dt.sumCanePrice04 = (dt.canePrice * dt.sumlastArea04);
    dt.sumCanePrice05 = (dt.canePrice * dt.sumlastArea05);
    dt.sumCanePrice06 = (dt.canePrice * dt.sumlastArea06);
    dt.sumCanePrice07 = (dt.canePrice * dt.sumlastArea07);

    dt.sumCutCost01 = (dt.DeCutCost * dt.sumlastArea01);
    dt.sumCutCost02 = (dt.DeCutCost * dt.sumlastArea02);
    dt.sumCutCost03 = (dt.DeCutCost * dt.sumlastArea03);
    dt.sumCutCost04 = (dt.DeCutCost * dt.sumlastArea04);
    dt.sumCutCost05 = (dt.DeCutCost * dt.sumlastArea05);
    dt.sumCutCost06 = (dt.DeCutCost * dt.sumlastArea06);
    dt.sumCutCost07 = (dt.DeCutCost * dt.sumlastArea07);

    dt.sumlastCanePrice01 = (dt.sumCanePrice01 - dt.sumCutCost01);
    dt.sumlastCanePrice02 = (dt.sumCanePrice02 - dt.sumCutCost02);
    dt.sumlastCanePrice03 = (dt.sumCanePrice03 - dt.sumCutCost03);
    dt.sumlastCanePrice04 = (dt.sumCanePrice04 - dt.sumCutCost04);
    dt.sumlastCanePrice05 = (dt.sumCanePrice05 - dt.sumCutCost05);
    dt.sumlastCanePrice06 = (dt.sumCanePrice06 - dt.sumCutCost06);
    dt.sumlastCanePrice07 = (dt.sumCanePrice07 - dt.sumCutCost07);

    dt.cutHarvester04 = (dt.cutHarvester02 - dt.cutHarvester03);
    dt.cutHarvester05 = (dt.cutHarvester01 * dt.cutHarvester03);
    dt.cutHarvester08 = ((dt.cutHarvester02 - dt.cutHarvester03) * dt.cutHarvester01);

    dt.cutService04 = (dt.cutService02 - dt.cutService03);
    dt.cutService05 = (dt.cutService01 * dt.cutService03);
    dt.cutService08 = ((dt.cutService02 - dt.cutService03) * dt.cutService01);

    dt.TruckService04 = (dt.TruckService02 - dt.TruckService03);
    dt.TruckService05 = (dt.TruckService01 * dt.TruckService03);
    dt.TruckService08 = ((dt.TruckService02 - dt.TruckService03) * dt.TruckService01);

    dt.ForkliftService04 = (dt.ForkliftService02 - dt.ForkliftService03);
    dt.ForkliftService05 = (dt.ForkliftService01 * dt.ForkliftService03);
    dt.ForkliftService08 = ((dt.ForkliftService02 - dt.ForkliftService03) * dt.ForkliftService01);

    dt.TractorService04 = (dt.TractorService02 - dt.TractorService03);
    dt.TractorService05 = (dt.TractorService01 * dt.TractorService03);
    dt.TractorService08 = ((dt.TractorService02 - dt.TractorService03) * dt.TractorService01);

    dt.burden01_01 = dt.sumArea01 * 3500;
    dt.burden01_02 = dt.sumArea02 * 3500;
    dt.burden01_03 = dt.sumArea03 * 3500;
    dt.burden01_04 = dt.sumArea04 * 3500;
    dt.burden01_05 = dt.sumArea05 * 3500;
    dt.burden01_06 = dt.sumArea06 * 3500;
    dt.burden01_07 = dt.sumArea07 * 3500;

    //**---**//
    dt.debtList1Sum = (dt.debtList1_01 + dt.debtList1_02 + dt.debtList1_03 + dt.debtList1_04 + dt.debtList1_05 + dt.debtList1_06 + dt.debtList1_07);
    dt.debtList2Sum = (dt.debtList2_01 + dt.debtList2_02 + dt.debtList2_03 + dt.debtList2_04 + dt.debtList2_05 + dt.debtList2_06 + dt.debtList2_07);
    dt.debtList3Sum = (dt.debtList3_01 + dt.debtList3_02 + dt.debtList3_03 + dt.debtList3_04 + dt.debtList3_05 + dt.debtList3_06 + dt.debtList3_07);

    dt.interest01_01 = (dt.debtList1Sum * dt.interest * 365) / 36500;
    dt.interest01_02 = ((dt.debtList1Sum - dt.debtList1_01) * dt.interest * 365) / 36500;
    dt.interest01_03 = ((dt.debtList1Sum - dt.debtList1_01 - dt.debtList1_02) * dt.interest * 365) / 36500;
    dt.interest01_04 = ((dt.debtList1Sum - dt.debtList1_01 - dt.debtList1_02 - dt.debtList1_03) * dt.interest * 365) / 36500;
    dt.interest01_05 = ((dt.debtList1Sum - dt.debtList1_01 - dt.debtList1_02 - dt.debtList1_03 - dt.debtList1_04) * dt.interest * 365) / 36500;
    dt.interest01_06 = ((dt.debtList1Sum - dt.debtList1_01 - dt.debtList1_02 - dt.debtList1_03 - dt.debtList1_04 - dt.debtList1_05) * dt.interest * 365) / 36500;
    dt.interest01_07 = ((dt.debtList1Sum - dt.debtList1_01 - dt.debtList1_02 - dt.debtList1_03 - dt.debtList1_04 - dt.debtList1_05 - dt.debtList1_06) * dt.interest * 365) / 36500;
    dt.interest01_sum = dt.interest01_01 + dt.interest01_02 + dt.interest01_03 + dt.interest01_04 + dt.interest01_05 + dt.interest01_06 + dt.interest01_07;
    dt.PrincipalInt01_01 = dt.debtList1_01 + dt.interest01_01;
    dt.PrincipalInt01_02 = dt.debtList1_02 + dt.interest01_02;
    dt.PrincipalInt01_03 = dt.debtList1_03 + dt.interest01_03;
    dt.PrincipalInt01_04 = dt.debtList1_04 + dt.interest01_04;
    dt.PrincipalInt01_05 = dt.debtList1_05 + dt.interest01_05;
    dt.PrincipalInt01_06 = dt.debtList1_06 + dt.interest01_06;
    dt.PrincipalInt01_07 = dt.debtList1_07 + dt.interest01_07;
    dt.PrincipalInt01_sum = dt.PrincipalInt01_01 + dt.PrincipalInt01_02 + dt.PrincipalInt01_03 + dt.PrincipalInt01_04 + dt.PrincipalInt01_05 + dt.PrincipalInt01_06 + dt.PrincipalInt01_07;

    dt.interest02_01 = (dt.debtList2Sum * dt.interest * 365) / 36500;
    dt.interest02_02 = ((dt.debtList2Sum - dt.debtList2_01) * dt.interest * 365) / 36500;
    dt.interest02_03 = ((dt.debtList2Sum - dt.debtList2_01 - dt.debtList2_02) * dt.interest * 365) / 36500;
    dt.interest02_04 = ((dt.debtList2Sum - dt.debtList2_01 - dt.debtList2_02 - dt.debtList2_03) * dt.interest * 365) / 36500;
    dt.interest02_05 = ((dt.debtList2Sum - dt.debtList2_01 - dt.debtList2_02 - dt.debtList2_03 - dt.debtList2_04) * dt.interest * 365) / 36500;
    dt.interest02_06 = ((dt.debtList2Sum - dt.debtList2_01 - dt.debtList2_02 - dt.debtList2_03 - dt.debtList2_04 - dt.debtList2_05) * dt.interest * 365) / 36500;
    dt.interest02_07 = ((dt.debtList2Sum - dt.debtList2_01 - dt.debtList2_02 - dt.debtList2_03 - dt.debtList2_04 - dt.debtList2_05 - dt.debtList2_06) * dt.interest * 365) / 36500;
    dt.interest02_sum = dt.interest02_01 + dt.interest02_02 + dt.interest02_03 + dt.interest02_04 + dt.interest02_05 + dt.interest02_06 + dt.interest02_07;
    dt.PrincipalInt02_01 = dt.debtList2_01 + dt.interest02_01;
    dt.PrincipalInt02_02 = dt.debtList2_02 + dt.interest02_02;
    dt.PrincipalInt02_03 = dt.debtList2_03 + dt.interest02_03;
    dt.PrincipalInt02_04 = dt.debtList2_04 + dt.interest02_04;
    dt.PrincipalInt02_05 = dt.debtList2_05 + dt.interest02_05;
    dt.PrincipalInt02_06 = dt.debtList2_06 + dt.interest02_06;
    dt.PrincipalInt02_07 = dt.debtList2_07 + dt.interest02_07;
    dt.PrincipalInt02_sum = dt.PrincipalInt02_01 + dt.PrincipalInt02_02 + dt.PrincipalInt02_03 + dt.PrincipalInt02_04 + dt.PrincipalInt02_05 + dt.PrincipalInt02_06 + dt.PrincipalInt02_07;

    dt.interest03_01 = (dt.debtList3Sum * dt.interest * 365) / 36500;
    dt.interest03_02 = ((dt.debtList3Sum - dt.debtList3_01) * dt.interest * 365) / 36500;
    dt.interest03_03 = ((dt.debtList3Sum - dt.debtList3_01 - dt.debtList3_02) * dt.interest * 365) / 36500;
    dt.interest03_04 = ((dt.debtList3Sum - dt.debtList3_01 - dt.debtList3_02 - dt.debtList3_03) * dt.interest * 365) / 36500;
    dt.interest03_05 = ((dt.debtList3Sum - dt.debtList3_01 - dt.debtList3_02 - dt.debtList3_03 - dt.debtList3_04) * dt.interest * 365) / 36500;
    dt.interest03_06 = ((dt.debtList3Sum - dt.debtList3_01 - dt.debtList3_02 - dt.debtList3_03 - dt.debtList3_04 - dt.debtList3_05) * dt.interest * 365) / 36500;
    dt.interest03_07 = ((dt.debtList3Sum - dt.debtList3_01 - dt.debtList3_02 - dt.debtList3_03 - dt.debtList3_04 - dt.debtList3_05 - dt.debtList3_06) * dt.interest * 365) / 36500;
    dt.interest03_sum = dt.interest03_01 + dt.interest03_02 + dt.interest03_03 + dt.interest03_04 + dt.interest03_05 + dt.interest03_06 + dt.interest03_07;
    dt.PrincipalInt03_01 = dt.debtList3_01 + dt.interest03_01;
    dt.PrincipalInt03_02 = dt.debtList3_02 + dt.interest03_02;
    dt.PrincipalInt03_03 = dt.debtList3_03 + dt.interest03_03;
    dt.PrincipalInt03_04 = dt.debtList3_04 + dt.interest03_04;
    dt.PrincipalInt03_05 = dt.debtList3_05 + dt.interest03_05;
    dt.PrincipalInt03_06 = dt.debtList3_06 + dt.interest03_06;
    dt.PrincipalInt03_07 = dt.debtList3_07 + dt.interest03_07;
    dt.PrincipalInt03_sum = dt.PrincipalInt03_01 + dt.PrincipalInt03_02 + dt.PrincipalInt03_03 + dt.PrincipalInt03_04 + dt.PrincipalInt03_05 + dt.PrincipalInt03_06 + dt.PrincipalInt03_07;


    this.dataplant[0] = dt;
  }

  THtoLocalstring(date: any) {
    const date1 = new Date(date);
    if (!date1) return '';
    let options: any = {
      year: "numeric",
      month: "short",
      day: "numeric",
      /*hour: "2-digit",
      minute  : "2-digit", 
      second  : "2-digit",*/
      timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }
  print() {
    window.print();
  }

  ngOnDestroy(): void {

    this.farmerdata = null;
    this.onefarmerdata = null;
    this.loanData = null;

  }
}
